import { Injectable, NgZone } from '@angular/core';

import { ConversationEventMessage } from '../models';
import { ConversationCommunicationService } from '../../services/conversation-communication.service';
import { ScopedWebSocketBaseService } from './scoped-websocket-base.service';

@Injectable({
  providedIn: 'root'
})
export class ConversationWebsocketService extends ScopedWebSocketBaseService {
  constructor(
    zone: NgZone,
    private readonly conversationCommunicationService: ConversationCommunicationService
  ) {
    super('Conversation WS', zone);
  }

  protected buildUrl(userId: string, token: string): string {
    return this.buildDomainSocketUrl('ConversationManagement', userId, token);
  }

  protected handleParsedMessage(data: ConversationEventMessage): void {
    if (!data || typeof data !== 'object') {
      console.warn('Ignoring invalid conversation payload', data);
      return;
    }

    if ((data as any).type === 'heartbeat') {
      console.debug('Ignoring heartbeat on Conversation WS', data);
      return;
    }

    if (data.event_type && data.event_type !== 'conversation_event') {
      console.warn('Ignoring invalid conversation payload', data);
      return;
    }

    const conversationId = data.conversation_id ?? data.conversationId;
    if (!conversationId) {
      console.warn('Ignoring invalid conversation payload', data);
      return;
    }

    this.conversationCommunicationService.emitConversationEvent(data);
  }
}
